<div class="onboarding-checklist-wrapper" [ngStyle]="{'z-index': isSubscriptionExpired ? 1 : 99999}">
  <div class="onboarding-vertically-center">
    <div class="onboarding-checklist-body">
      <div class="onboarding-checklist-timeline">
        <div class="onboarding-reminder">
          <span class="font-white font-14 font-weight-bold">
            Days remaining: {{remainingTrialDays}}
          </span>
        </div>
        <div class="onboarding-progress-bar-wrapper">
          <div class="onboarding-progress-bar">
            <div class="onboarding-progress" [ngStyle]="{'width': remainingDayPercentage}"></div>
          </div>
        </div>
        <div class="onboarding-action-btn pointer"> <a (click)="expiry(true)" class="btn btn-orange"
            style="background-color: #F08A3F;">
            {{!isSubscriptionRequested? 'Subscribe now': 'Subscription: In Process'}}
          </a>
        </div>
      </div>
      <div class="onboarding-checklist-stepper">

        <ul class="onboarding-checklist-stepper-list">
          <li class="onboarding-checklist-stepper-list-item active" [ngClass]="{ 'active': isLogoUploaded }">
            <button class="btn dropdown-toggle btn-stepper" type="button" id="info" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <i class="icon fas fa-check"></i>
            </button>
            <div class="onboarding-stepper-text">Info</div>
            <div class="dropdown-menu onboarding-dropdown-menu" aria-labelledby="info">
              <div class="arrow-up"></div>
              <div class="onboarding-dropdown-content text-white">
                <div class="onboarding-ddl-header">
                  <h2 class="mb-2 text-white font-20 font-bold">
                    <span>Explore Trial</span>
                    <span class="font-12 font-bold font-gray-75 text-uppercase hide">Hide</span>
                  </h2>
                  <p class="font-gray-95 font-14">Here are some exciting AutoLeap features for you to try</p>
                </div>
                <ul class="onboarding-dropdown-content-list">
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isLogoUploaded }">
                    <i class="fal fa-check-circle"></i>
                    <span class="font-16 font-bold" [routerLink]="'/settings/company'">Add General Information</span>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isAppointmentCreated }">
                    <i class="fal fa-calendar-day"></i>
                    <span class="font-16 font-bold" (click)="handleSetUpApt()">Set up your first Appointment</span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2" (click)="openVideoPreview('appt')"></i>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isROCreated }">
                    <i class="fal fa-file-alt"></i>
                    <span class="font-16 font-bold" (click)="handleSetupRo()">Create your first Repair Order </span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2" (click)="openVideoPreview('ro')"></i>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isUserCreated }"
                    (click)="handleSetupInvite()">
                    <i class="fal fa-user-hard-hat"></i>
                    <span class="font-16 font-bold">Invite Techs and Admins</span>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" (click)="partsOrdering()"
                    [ngClass]="{ 'completed': isPartsTechUsed }">
                    <i class="fal fa-plug"></i>
                    <span class="font-16 font-bold">Try Parts Ordering</span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2"
                      (click)="openVideoPreview('partstech')"></i>
                  </li>
                </ul>
                <div class="onboarding-dropdown-footer">
                  <div class="ml-auto">
                    <!-- <a href="javascript:;" class="next-btn mr-3">Next item</a> -->
                    <button class="btn btn-primary btn-lg" (click)="handleSetUpApt()">Add appointment</button>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="onboarding-checklist-stepper-list-item active" [ngClass]="{ 'active': isAppointmentCreated }">
            <button class="btn dropdown-toggle btn-stepper" type="button" id="appointment" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <i class="icon fas fa-calendar-day"></i>
            </button>
            <div class="onboarding-stepper-text">Appointment</div>
            <div class="dropdown-menu onboarding-dropdown-menu" aria-labelledby="info">
              <div class="arrow-up"></div>
              <div class="onboarding-dropdown-content text-white">
                <div class="onboarding-ddl-header">
                  <h2 class="mb-2 text-white font-20 font-bold">
                    <span>Explore Trial</span>
                    <span class="font-12 font-bold font-gray-75 text-uppercase hide">Hide</span>
                  </h2>
                  <p class="font-gray-95 font-14">Here are some exciting AutoLeap features for you to try</p>
                </div>
                <ul class="onboarding-dropdown-content-list">
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isLogoUploaded }">
                    <i class="fal fa-check-circle"></i>
                    <span class="font-16 font-bold">Add General Information</span>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isAppointmentCreated }">
                    <i class="fal fa-calendar-day"></i>
                    <span class="font-16 font-bold" (click)="handleSetUpApt()">Set up your first Appointment</span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2" (click)="openVideoPreview('appt')"></i>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isROCreated }">
                    <i class="fal fa-file-alt"></i>
                    <span class="font-16 font-bold">Create your first Repair Order </span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2" (click)="openVideoPreview('ro')"></i>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isUserCreated }"
                    (click)="handleSetupInvite()">
                    <i class="fal fa-user-hard-hat"></i>
                    <span class="font-16 font-bold">Invite Techs and Admins</span>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isPartsTechUsed }"
                    (click)="partsOrdering()">
                    <i class="fal fa-plug"></i>
                    <span class="font-16 font-bold">Try Parts Ordering</span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2"
                      (click)="openVideoPreview('partstech')"></i>
                  </li>
                </ul>
                <div class="onboarding-dropdown-footer">
                  <div class="ml-auto">
                    <!-- <a href="javascript:;" class="next-btn mr-3">Next item</a> -->
                    <button class="btn btn-primary btn-lg" (click)="handleSetUpApt()">Add appointment</button>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="onboarding-checklist-stepper-list-item active" [ngClass]="{ 'active': isROCreated }">
            <button class="btn dropdown-toggle btn-stepper" type="button" id="ro" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <i class="icon fas fa-file-alt"></i>
            </button>
            <div class="onboarding-stepper-text">Repair order</div>
            <div class="dropdown-menu onboarding-dropdown-menu" aria-labelledby="info">
              <div class="arrow-up"></div>
              <div class="onboarding-dropdown-content text-white">
                <div class="onboarding-ddl-header">
                  <h2 class="mb-2 text-white font-20 font-bold">
                    <span>Explore Trial</span>
                    <span class="font-12 font-bold font-gray-75 text-uppercase hide">Hide</span>
                  </h2>
                  <p class="font-gray-95 font-14">Here are some exciting AutoLeap features for you to try</p>
                </div>
                <ul class="onboarding-dropdown-content-list">
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isLogoUploaded }">
                    <i class="fal fa-check-circle"></i>
                    <span class="font-16 font-bold">Add General Information</span>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isAppointmentCreated }">
                    <i class="fal fa-calendar-day"></i>
                    <span class="font-16 font-bold" (click)="handleSetUpApt()">Set up your first Appointment</span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2" (click)="openVideoPreview('appt')"></i>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isROCreated }">
                    <i class="fal fa-file-alt"></i>
                    <span class="font-16 font-bold" (click)="handleSetupRo()">Create your first Repair Order </span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2" (click)="openVideoPreview('ro')"></i>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isUserCreated }"
                    (click)="handleSetupInvite()">
                    <i class="fal fa-user-hard-hat"></i>
                    <span class="font-16 font-bold">Invite Techs and Admins</span>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isPartsTechUsed }"
                    (click)="partsOrdering()">
                    <i class="fal fa-plug"></i>
                    <span class="font-16 font-bold">Try Parts Ordering</span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2"
                      (click)="openVideoPreview('partstech')"></i>
                  </li>
                </ul>
                <div class="onboarding-dropdown-footer">
                  <div class="ml-auto">
                    <!-- <a href="javascript:;" class="next-btn mr-3">Next item</a> -->
                    <button class="btn btn-primary btn-lg" (click)="handleSetUpApt()">Add appointment</button>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="onboarding-checklist-stepper-list-item active" [ngClass]="{ 'active': isUserCreated }">
            <button type="button" class="btn dropdown-toggle btn-stepper" id="tech" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <i class="icon fas fa-user-hard-hat"></i>
            </button>
            <div class="onboarding-stepper-text">Invite Techs</div>
            <div class="dropdown-menu onboarding-dropdown-menu" aria-labelledby="info">
              <div class="arrow-up"></div>
              <div class="onboarding-dropdown-content text-white">
                <div class="onboarding-ddl-header">
                  <h2 class="mb-2 text-white font-20 font-bold">
                    <span>Explore Trial</span>
                    <span class="font-12 font-bold font-gray-75 text-uppercase hide">Hide</span>
                  </h2>
                  <p class="font-gray-95 font-14">Here are some exciting AutoLeap features for you to try</p>
                </div>
                <ul class="onboarding-dropdown-content-list">
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isLogoUploaded }">
                    <i class="fal fa-check-circle"></i>
                    <span class="font-16 font-bold">Add General Information</span>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isAppointmentCreated }">
                    <i class="fal fa-calendar-day"></i>
                    <span class="font-16 font-bold" (click)="handleSetUpApt()">Set up your first Appointment</span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2" (click)="openVideoPreview('appt')"></i>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isROCreated }">
                    <i class="fal fa-file-alt"></i>
                    <span class="font-16 font-bold" (click)="handleSetupRo()">Create your first Repair Order </span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2" (click)="openVideoPreview('ro')"></i>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isUserCreated }"
                    (click)="handleSetupInvite()">
                    <i class="fal fa-user-hard-hat"></i>
                    <span class="font-16 font-bold">Invite Techs and Admins</span>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isPartsTechUsed }"
                    (click)="partsOrdering()">
                    <i class="fal fa-plug"></i>
                    <span class="font-16 font-bold">Try Parts Ordering</span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2"
                      (click)="openVideoPreview('partstech')"></i>
                  </li>
                </ul>
                <div class="onboarding-dropdown-footer">
                  <div class="ml-auto">
                    <!-- <a href="javascript:;" class="next-btn mr-3">Next item</a> -->
                    <button class="btn btn-primary btn-lg" (click)="handleSetUpApt()">Add appointment</button>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="onboarding-checklist-stepper-list-item active" [ngClass]="{ 'active': isPartsTechUsed }">
            <button type="button" class="btn dropdown-toggle btn-stepper last-child" id="order" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <i class="icon fas fa-truck"></i>
            </button>
            <div class="onboarding-stepper-text">Order Parts</div>
            <div *ngIf="!isPartsTechUsed || !isLogoUploaded || !isUserCreated || !isROCreated || !isAppointmentCreated "
              class="dropdown-menu onboarding-dropdown-menu" aria-labelledby="info">
              <div class="arrow-up"></div>
              <div class="onboarding-dropdown-content text-white">
                <div class="onboarding-ddl-header">
                  <h2 class="mb-2 text-white font-20 font-bold">
                    <span>Explore Trial</span>
                    <span class="font-12 font-bold font-gray-75 text-uppercase hide">Hide</span>
                  </h2>
                  <p class="font-gray-95 font-14">Here are some exciting AutoLeap features for you to try</p>
                </div>
                <ul class="onboarding-dropdown-content-list">
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isLogoUploaded }">
                    <i class="fal fa-check-circle"></i>
                    <span class="font-16 font-bold">Add General Information</span>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isAppointmentCreated }">
                    <i class="fal fa-calendar-day"></i>
                    <span class="font-16 font-bold" (click)="handleSetUpApt()">Set up your first Appointment</span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2" (click)="openVideoPreview('appt')"></i>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isROCreated }">
                    <i class="fal fa-file-alt"></i>
                    <span class="font-16 font-bold" (click)="handleSetupRo()">Create your first Repair Order </span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2" (click)="openVideoPreview('ro')"></i>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isUserCreated }"
                    (click)="handleSetupInvite()">
                    <i class="fal fa-user-hard-hat"></i>
                    <span class="font-16 font-bold">Invite Techs and Admins</span>
                  </li>
                  <li class="onboarding-dropdown-content-list-item" [ngClass]="{ 'completed': isPartsTechUsed }"
                    (click)="partsOrdering()">
                    <i class="fal fa-plug"></i>
                    <span class="font-16 font-bold">Try Parts Ordering</span>
                    <i class="video-apt fas fa-video font-18 text-primary pl-2"
                      (click)="openVideoPreview('partstech')"></i>
                  </li>
                </ul>
                <div class="onboarding-dropdown-footer">
                  <div class="ml-auto">
                    <!-- <a href="javascript:;" class="next-btn mr-3">Next item</a> -->
                    <button class="btn btn-primary btn-lg" (click)="handleSetUpApt()">Add appointment</button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="isPartsTechUsed && isLogoUploaded && isUserCreated && isROCreated && isAppointmentCreated "
              class="dropdown-menu onboarding-dropdown-menu" aria-labelledby="info">
              <div class="arrow-up"></div>
              <div class="onboarding-dropdown-content text-white">
                <div class="onboarding-ddl-header">
                  <h2 class="mb-2 text-white font-20 font-bold">
                    <span>Explore Trial</span>
                    <span class="font-12 font-bold font-gray-75 text-uppercase hide">Hide</span>
                  </h2>
                </div>
                <div class="onboarding-completed-wrapper">
                  <i class="fal fa-trophy-alt"></i>
                  <p class="mt-4">Congratulations!</p>
                  <div class="greeting-text">You have completed all tasks</div>
                  <a class="btn btn-primary pointer hide">Close</a>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
